import type { Property, Project } from '../types';

/** Titane Proméa — boutons, liens marketing, formulaires par défaut. */
export const PROGRAM_BRAND_ACCENT = '#3C3C3B' as const;

/** Accent carte / badges — orange Proméa uniforme (indépendant du type de bien). */
export function propertyAccentColor(_type: Property['type']): string {
  return PROGRAM_BRAND_ACCENT;
}

/** Accent carte / fiche — orange Proméa uniforme (indépendant du type de programme). */
export function projectAccentColor(_type: Project['type']): string {
  return PROGRAM_BRAND_ACCENT;
}

const PROPERTY_CATEGORY_LABELS: Record<Property['type'], string> = {
  terrain: 'Terrain à bâtir',
  appartement: 'Appartement',
  maison: 'Maison',
  bureau: 'Bureaux',
  local: 'Locaux d\'activité',
};

const PROJECT_CATEGORY_LABELS: Record<Project['type'], string> = {
  terrain: 'Terrain à bâtir',
  collectif: 'Appartement',
  maison: 'Maison',
  bureaux: 'Bureaux',
  activites: 'Locaux d\'activité',
};

export function propertyProgramCategoryLabel(type: Property['type']): string {
  return PROPERTY_CATEGORY_LABELS[type] ?? 'Programme';
}

export function projectProgramCategoryLabel(type: Project['type']): string {
  return PROJECT_CATEGORY_LABELS[type] ?? 'Programme';
}

/** Libellés courts pour badges sur vignettes (lisibilité sans tout homogénéiser visuellement). */
export function propertyProgramCategoryBadgeCompact(type: Property['type']): string {
  const m: Record<Property['type'], string> = {
    terrain: 'Terrain',
    appartement: 'Appartement',
    maison: 'Maison',
    bureau: 'Bureaux',
    local: 'Activités',
  };
  return m[type] ?? 'Programme';
}

export function projectProgramCategoryBadgeCompact(type: Project['type']): string {
  const m: Record<Project['type'], string> = {
    terrain: 'Terrain',
    collectif: 'Appartement',
    maison: 'Maison',
    bureaux: 'Bureaux',
    activites: 'Activités',
  };
  return m[type] ?? 'Programme';
}

/** Libellé statut programme (carte, fiche). */
export function projectStatusLabel(status: Project['status']): string {
  switch (status) {
    case 'en-cours':
      return 'Travaux en cours';
    case 'planifie':
      return 'Lancement commercial';
    case 'livre':
      return 'Programme livré';
    default:
      return 'Commercialisation';
  }
}

/** Bandeau statut — toujours fond sombre (noir / anthracite). */
export function projectStatusBadgeClass(_status: Project['status']): string {
  return 'bg-neutral-800 text-white';
}

/** Bandeau offre / dispositif — orange Proméa uniforme. */
export function programSecondaryBadgeClass(): string {
  return 'bg-orange-500 text-white';
}

/** Style commun des bandeaux image (coins droits arrondis). */
export const PROGRAM_IMAGE_BANNER_BASE =
  'inline-block rounded-r-md px-3 py-1.5 text-[11px] font-bold uppercase leading-tight tracking-wide shadow-md';

/** Pastilles catalogue vue Lots / bandeaux programme (coins peu arrondis). */
export const CATALOG_PROGRAM_CHIP_BASE =
  'inline-flex items-center rounded-md px-3 py-1.5 text-xs font-semibold leading-snug tracking-wide shadow-sm';

/** Atouts / commodités — contour sur fond sombre. */
export const CATALOG_PROGRAM_CHIP_ATOUT =
  'inline-flex items-center rounded-md border border-white/15 bg-white/[0.06] px-2.5 py-1 text-xs font-medium leading-snug text-white/75';

/** @deprecated Conservé pour compatibilité — tout est en orange. */
export type ProgramSecondaryBadgeTone = 'promo' | 'scheme';
